import { COUNTRIES } from "../features/auth/independent/countries";

const COUNTRY_CURRENCIES = Object.fromEntries(COUNTRIES.map((country) => [country.code, country.currency]));

let operatingCurrencyCode = "NGN";

export function normalizeDollarSymbol(value) {
  return String(value || "").replace(/US\$|\$US|\bUSD\b/g, () => "$");
}

export function resolveOperatingCurrencyCode(countryCode) {
  return COUNTRY_CURRENCIES[String(countryCode || "").trim().toUpperCase()] || "NGN";
}

export function setOperatingCountryCode(countryCode) {
  operatingCurrencyCode = resolveOperatingCurrencyCode(countryCode);
}

export function getOperatingCurrencyCode() {
  return operatingCurrencyCode;
}

export function formatOperatingCurrency(value, locale) {
  const parts = new Intl.NumberFormat(locale, {
    currency: operatingCurrencyCode,
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    style: "currency",
  }).formatToParts(Number(value) || 0);

  return parts
    .map((part, index) => {
      if (part.type !== "currency") return part.value;
      const symbol = operatingCurrencyCode === "USD" ? "$" : part.value;
      const previous = parts[index - 1]?.type;
      const next = parts[index + 1]?.type;
      if (next === "integer") return `${symbol}\u202F`;
      if (previous === "fraction" || previous === "integer") return `\u202F${symbol}`;
      return symbol;
    })
    .join("");
}
